import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

// @mui material components
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

// Material Dashboard 2 React example components
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout";
import DashboardNavbar from "monitor/Navbars/DashboardNavbar";
import Footer from "monitor/Footer";
import MDInput from "components/MDInput";
import { Link } from "react-router-dom";
import { InputLabel, Select, MenuItem, FormControl, InputAdornment, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
import ModalSelectorMultiple from "components/ModalSelectorMultiple";

// Importa el servicio
import {
  fetchPost,
  fetchUserById,
  updateUser,
  fetchRoles,
  fetchCurrentRoles,
  fetchEmpre,
  fetchCurrentEmpresas,
  fetchSucursalesByEmpresas,
  fetchEventosByEmpresas,
  fetchCurrentSucursal,
  fetchCurrentEvento,
  fetchUserToken,
  generateUserToken,
} from "./service"
import { useMaterialUIController } from "context"

function Add() {
  const mode = localStorage.getItem("checkboxState")
  const [userToEdit, setUserToEdit] = useState(null)
  const navigate = useNavigate()
  const { id } = useParams()
  const [formData, setFormData] = useState({
    nombre: "",
    ci: "",
    telefono: "",
    correo: "",
    username: "",
    password: "",
    repeatPassword: "",
  })
  const [option, setOption] = useState({ idRoles: "", nombre: "" })
  const [optionEmpresas, setOptionEmpresas] = useState([])
  const [optionSucursal, setOptionSucursal] = useState([])
  const [optionEvento, setOptionEvento] = useState([])
  const [roles, setRoles] = useState([])
  const [empresas, setEmpresas] = useState([])
  const [sucursales, setSucursales] = useState([])
  const [eventos, setEventos] = useState([])
  const [generatedToken, setGeneratedToken] = useState("")
  const [isGeneratingToken, setIsGeneratingToken] = useState(false)
  const [controller] = useMaterialUIController()
  const { darkMode } = controller

  useEffect(() => {
    // Fetch roles and empresas on mount
    fetchRoles().then((data) => {
      setRoles(data)
    })

    fetchEmpre().then((data) => {
      setEmpresas(data)
    })
  }, [])

  useEffect(() => {
    // Fetch user details and related data if editing
    setGeneratedToken("")

    if (id) {
      fetchUserById(id).then((user) => {
        setUserToEdit(user)
        setFormData({
          nombre: user.personas.nombre || "",
          ci: user.personas.ci || "",
          telefono: user.personas.telefono || "",
          correo: user.personas.email || "",
          username: user.username || "",
          password: "",
          repeatPassword: "",
        })
      })

      fetchCurrentRoles(id).then((data) => {
        if (data.length > 0 && data[0]?.idRoles && data[0]?.nombre) {
          setOption({ idRoles: data[0].idRoles, nombre: data[0].nombre })
        }
      })

      fetchCurrentEmpresas(id).then((data) => {
        // La empresa viene repetida si el usuario tiene sucursales y eventos de ella
        const empresaIds = [...new Set((data || []).map((emp) => emp.idEmpresa))]
        setOptionEmpresas(empresaIds)

        fetchSucursalesByEmpresas(empresaIds).then(setSucursales)
        fetchEventosByEmpresas(empresaIds).then(setEventos)
      })

      fetchCurrentSucursal(id).then((data) => {
        const selectedIds = data?.map((item) => item.idSucursal)
        setOptionSucursal(selectedIds || [])
      })
      fetchCurrentEvento(id).then((data) => {
        const selectedIds = data?.map((item) => item.idEvento)
        setOptionEvento(selectedIds || [])
      })

      fetchUserToken(id).then((data) => {
        setGeneratedToken(data?.token || "")
      })
    }
  }, [id])

  const handleGenerateToken = async () => {
    if (!id || !userToEdit) {
      return
    }

    const hasExistingToken = Boolean(generatedToken?.trim())
    const result = await Swal.fire({
      title: hasExistingToken ? "¿Reemplazar token existente?" : "¿Generar nuevo token?",
      text: hasExistingToken
        ? "Este usuario ya tiene un token y será reemplazado."
        : "Se generará un nuevo token para este usuario.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: hasExistingToken ? "Sí, reemplazar" : "Sí, generar",
      cancelButtonText: "Cancelar",
    })

    if (!result.isConfirmed) {
      return
    }

    try {
      setIsGeneratingToken(true)
      const data = await generateUserToken(id)
      setGeneratedToken(data.token)
      showToast({ icon: "success", title: "Token generado" })
    } catch (error) {
      console.error("Error al generar token:", error)
    } finally {
      setIsGeneratingToken(false)
    }
  }

  const handleCopyToken = async () => {
    if (!generatedToken) {
      return
    }

    try {
      await navigator.clipboard.writeText(generatedToken)
      showToast({ icon: "success", title: "Token copiado." })
    } catch (error) {
      showToast({ icon: "error", title: "Error", text: "No se pudo copiar el token." })
    }
  }

  const validateEmail = (value) => {
    // Expresión regular para validar el correo electrónico
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!emailPattern.test(value)) {
      showToast({
        icon: "info",
        title: "Mensaje",
        text: "Por favor, ingresa un correo electrónico válido.",
      })
    }
  }

  const handleChangeSelect = (selectedIds) => {
    setOptionSucursal(selectedIds);
  };

  const handleChangeSelectEvento = (selectedIds) => {
    setOptionEvento(selectedIds);
  };

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleBlurCorreo = (event) => {
    validateEmail(event.target.value)
  }

  const handleBlur = (event) => {
    // validatePassword(event.target.value);
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Validación de campos requeridos
    if (!option) {
      showToast({ icon: "info", title: "Mensaje", text: "El campo Rol es obligatorio." })
      return
    }
    if (!formData.nombre.trim()) {
      showToast({ icon: "info", title: "Mensaje", text: "El campo Nombre y Apellido es obligatorio." })
      return
    }

    if (!formData.ci.trim()) {
      showToast({ icon: "info", title: "Mensaje", text: "El campo CI es obligatorio." })
      return
    }
    console.log(option?.nombre)

    if (optionEmpresas.length === 0) {
      showToast({ icon: "info", title: "Mensaje", text: "Debe seleccionar al menos una empresa." })
      return
    }

    if (option?.nombre !== "admin" && option?.nombre !== "superadmin") {
      if (optionSucursal.length === 0 && optionEvento.length === 0) {
        showToast({ icon: "info", title: "Mensaje", text: "Debe seleccionar al menos una sucursal o evento." })
        return
      }
      // La empresa no se guarda: sin sucursal ni evento elegido desaparece al guardar
      const empresaSinAsignar = empresas.find(
        (emp) =>
          optionEmpresas.includes(emp.idEmpresa) &&
          !sucursales.some((s) => s.empresa?.idEmpresa === emp.idEmpresa && optionSucursal.includes(s.idSucursal)) &&
          !eventos.some((ev) => ev.empresa?.idEmpresa === emp.idEmpresa && optionEvento.includes(ev.idEvento))
      )
      if (empresaSinAsignar) {
        showToast({
          icon: "info",
          title: "Mensaje",
          text: `Debe seleccionar al menos una sucursal o evento de ${empresaSinAsignar.descripcion}.`,
        })
        return
      }
    }

    if (!formData.username.trim()) {
      showToast({ icon: "info", title: "Mensaje", text: "El campo Usuario es obligatorio." })
      return
    }

    const data = {
      personas: {
        nombre: e.target.nombre.value,
        ci: e.target.ci.value,
        telefono: e.target.telefono.value,
        email: e.target.correo.value,
      },
      roles: [option],
      idSucursales: optionSucursal,
      idEventos: optionEvento,
      username: e.target.username.value,
      activo: true,
    }
    if (!userToEdit || (formData.password && formData.password === formData.repeatPassword)) {
      data.password = formData.password
    } else {
      delete data.password
    }

    // Expresión regular para validar el correo electrónico
    const emailPattern2 = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

    if (!emailPattern2.test(e.target.correo.value)) {
      showToast({ icon: "info", title: "Mensaje", text: "Por favor, ingresa un correo electrónico válido." })
      return
    }

    if (formData.password !== formData.repeatPassword) {
      showToast({ icon: "info", title: "Mensaje", text: "Las contraseñas no coinciden." })
      return
    }

    try {
      if (userToEdit) {
        await updateUser(id, data)
        showToast({ title: "Usuario actualizado exitosamente", icon: "success" })
      } else {
        await fetchPost(data)
        showToast({ title: "Usuario agregado exitosamente", icon: "success" })
      }
      navigate("/usuarios")
    } catch (error) {
      console.error("Error en la operación:", error)
    }
  }

  const handleEmpresasChange = (empresaIds) => {
    setOptionEmpresas(empresaIds)
    fetchSucursalesByEmpresas(empresaIds).then((data) => {
      setSucursales(data)
      setOptionSucursal((prev) => prev.filter((idSucursal) => data.some((s) => s.idSucursal === idSucursal)))
    })
    fetchEventosByEmpresas(empresaIds).then((data) => {
      setEventos(data)
      setOptionEvento((prev) => prev.filter((idEvento) => data.some((ev) => ev.idEvento === idEvento)))
    })
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={10}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h5">
                  {userToEdit ? "Editar usuario" : "Agregar usuario"}
                </MDTypography>
              </MDBox>
              <MDBox
                pt={2}
                px={2}
                id="formAddUs"
                onSubmit={handleSubmit}
                component="form"
                role="form"
              >
                <Grid container spacing={1}>
                  <Grid item xs={12} md={12}>
                    <MDBox mb={2}>
                      <ModalSelectorMultiple
                        value={optionEmpresas}
                        onChange={handleEmpresasChange}
                        items={empresas}
                        itemValue="idEmpresa"
                        itemLabel="descripcion"
                        label="Empresas"
                        placeholder="Seleccione empresas"
                        searchPlaceholder="Buscar empresa..."
                        emptyText="No se encontraron empresas"
                        fullWidth
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <ModalSelectorMultiple
                        value={optionSucursal || []}
                        onChange={handleChangeSelect}
                        items={sucursales}
                        itemValue="idSucursal"
                        itemLabel="descripcion"
                        renderChip={(sucur) => `${sucur.empresa?.descripcion} - ${sucur.descripcion}`}
                        label="Sucursales"
                        placeholder="Seleccione sucursales"
                        searchPlaceholder="Buscar sucursal..."
                        emptyText="No se encontraron sucursales"
                        fullWidth
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <ModalSelectorMultiple
                        value={optionEvento || []}
                        onChange={handleChangeSelectEvento}
                        items={eventos}
                        itemValue="idEvento"
                        itemLabel="descripcion"
                        renderChip={(eve) => `${eve.empresa?.descripcion} - ${eve.descripcion}`}
                        label="Eventos"
                        placeholder="Seleccione eventos"
                        searchPlaceholder="Buscar evento..."
                        emptyText="No se encontraron eventos"
                        fullWidth
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      {roles.length > 0 ? (
                        <FormControl fullWidth>
                          <InputLabel>Rol</InputLabel>
                          <Select
                            required
                            type="text"
                            name="role"
                            value={option.idRoles}
                            label="Rol"
                            onChange={(e) => {
                              const selectedRole = roles.find((role) => role.idRoles === e.target.value)
                              setOption({ idRoles: e.target.value, nombre: selectedRole?.nombre || "" })
                            }}
                            fullWidth
                            sx={{ p: 1.5 }}
                          >
                            <MenuItem value="" key="">
                              Ninguno
                            </MenuItem>
                            {roles
                              ?.filter((selectedId) => selectedId !== "")
                              .map((role) => (
                                <MenuItem
                                  key={role.idRoles}
                                  value={role.idRoles}
                                  selected={role.idRoles === option.idRoles}
                                >
                                  {role.nombre}
                                </MenuItem>
                              ))}
                          </Select>
                        </FormControl>
                      ) : (
                        <MDTypography variant="body1">Cargando roles...</MDTypography>
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <MDInput
                        type="text"
                        name="nombre"
                        label="Nombre y Apellido"
                        fullWidth
                        required={true}
                        value={formData.nombre}
                        onChange={handleChange}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <MDInput
                        type="text"
                        name="ci"
                        label="Cedula de identidad"
                        fullWidth
                        required={true}
                        value={formData.ci}
                        onChange={handleChange}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <MDInput
                        type="text"
                        name="telefono"
                        label="Teléfono"
                        fullWidth
                        value={formData.telefono}
                        onChange={handleChange}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <MDInput
                        type="text"
                        name="correo"
                        label="Correo"
                        fullWidth
                        required={true}
                        value={formData.correo}
                        onChange={handleChange}
                        onBlur={handleBlurCorreo}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <MDInput
                        type="text"
                        name="username"
                        label="Usuario"
                        fullWidth
                        required={true}
                        value={formData.username}
                        onChange={handleChange}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <MDInput
                        type="password"
                        name="password"
                        label="Clave"
                        fullWidth
                        required={!userToEdit ? true : false}
                        value={formData.password}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDBox mb={2}>
                      <MDInput
                        type="password"
                        name="repeatPassword"
                        label="Repetir Clave"
                        fullWidth
                        required={!userToEdit ? true : false}
                        value={formData.repeatPassword}
                        onChange={handleChange}
                      />
                    </MDBox>
                  </Grid>
                </Grid>
                {userToEdit && (
                  <MDBox mb={2}>
                    <Grid container spacing={1}>
                      {generatedToken && (
                        <Grid item xs={12}>
                          <MDInput
                            type="text"
                            name="generatedToken"
                            label="Token de acceso"
                            fullWidth
                            value={generatedToken}
                            InputProps={{
                              readOnly: true,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    edge="end"
                                    color={darkMode ? "white" : "black"}
                                    onClick={handleCopyToken}
                                    aria-label="Copiar token"
                                  >
                                    <ContentCopyIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </MDBox>
                )}
                <MDBox mb={2} sx={{ textAlign: "center" }}>
                  <MDButton type="submit" variant="gradient" color="info" sx={{ mr: 1, width: 90 }}>
                    {userToEdit ? "Actualizar" : "Agregar"}
                  </MDButton>
                  {userToEdit && (
                    <MDButton
                      type="button"
                      variant="outlined"
                      color="warning"
                      onClick={handleGenerateToken}
                      disabled={isGeneratingToken}
                    >
                      {isGeneratingToken ? "Generando..." : "Generar Token"}
                    </MDButton>
                  )}
                  <Link to="/usuarios">
                    <MDButton
                      type="button"
                      variant="outlined"
                      color="info"
                      sx={{ ml: 1, width: 90 }}
                    >
                      Cancelar
                    </MDButton>
                  </Link>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Add
